import { Trans, useI18n } from '~/common/context';
import { SelectField } from '~/common/components';
import { PurchaseSearchHelpers } from '~/purchase/helpers';

const WcwSortField = () => {
  const { t } = useI18n();

  const SORT_OPTIONS = [
    {
      label: t('app.purchase.search_page.filter.sort.relevance'),
      value: PurchaseSearchHelpers.DEFAULT_SEARCH_SORT,
    },
    {
      label: t('app.purchase.search_page.filter.sort.price'),
      value: 'price',
    },
    {
      label: t('app.common.estimation_delivery'),
      value: 'estimatedDelivery',
    },
  ];

  return (
    <SelectField<false>
      name='sort'
      placeholder={
        <Trans i18nKey='app.purchase.search_page.filter.sort.default' />
      }
      options={SORT_OPTIONS}
      size='sm'
      isClearable={false}
      formGroupClassName='sorter-select'
    />
  );
};

export default WcwSortField;
